import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function CookieConsent() {
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem("cookieConsent");
        if (!consent) {
            // Small delay for better UX
            const timer = setTimeout(() => setShowBanner(true), 1000);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem("cookieConsent", "accepted");
        setShowBanner(false);
    };

    const handleDecline = () => {
        localStorage.setItem("cookieConsent", "declined");
        setShowBanner(false);
    };

    return (
        <AnimatePresence>
            {showBanner && (
                <motion.div
                    initial={{ y: 100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 100, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="fixed bottom-20 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-50"
                >
                    <div className="glass-card rounded-2xl p-6 border border-white/10 shadow-2xl">
                        <h3 className="font-primary font-semibold text-lg text-white mb-2">
                            🍪 Cookie Notice
                        </h3>
                        <p className="font-body text-sm text-zinc-400 mb-4">
                            We use cookies to enhance your experience, analyze site traffic, and for authentication.
                            By clicking "Accept", you consent to our use of cookies.
                        </p>
                        <div className="flex gap-3">
                            <button
                                onClick={handleAccept}
                                className="flex-1 px-4 py-2 rounded-xl font-secondary font-bold text-sm tracking-wider uppercase text-black gold-gradient hover:shadow-gold transition-all"
                            >
                                Accept
                            </button>
                            <button
                                onClick={handleDecline}
                                className="flex-1 px-4 py-2 rounded-xl font-secondary font-bold text-sm tracking-wider uppercase text-zinc-400 border border-white/10 hover:border-white/30 transition-all"
                            >
                                Decline
                            </button>
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
